<template>
    <div class="flex flex-col h-auto min-h-screen max-h-screen w-full bg-grey-700">
        <div class="w-full px-5 md:px-10 lg:px-32 xl:px-64 pt-4 pb-3 text-grey-80 text-3xl sm:text-4xl">
			<a @click="cancel" @keypress.enter="cancel" tabindex="0" class="cursor-pointer">
				<svg class="inline-block align-middle mr-1 -mt-1" width="30" height="30" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M19.375 23.25L11.625 15.5L19.375 7.75" class="stroke-current" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</a>
			
			Cancel
		</div>
		<div class="px-5 md:px-10 lg:px-32 xl:px-64 pt-1 pb-32 text-white text-xl overflow-x-hidden overflow-y-auto">
			<div v-if="error" class="mb-4 mb-1 pt-5 pb-4 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64 px-5 md:px-10 lg:px-32 xl:px-64 bg-grey-900 text-white text-xl font-body">
				{{ error }}
			</div>
			
			<h1 class="text-10xl text-red-200 leading-tight -mt-2">{{ route.length }}</h1>
			<h4 class="text-3xl text-white font-body leading-tight -mt-3">Checkpoints</h4>
			
			<h1 class="text-10xl text-red-200 leading-tight mt-2">{{ estimated_distance }}km</h1>
			<h4 class="text-3xl text-white font-body leading-tight -mt-3">Estimated route length*</h4>
			
			<h1 class="text-10xl text-red-200 leading-tight mt-2">{{ timeConvert(estimated_time) }}</h1>
			<h4 class="text-3xl text-white font-body leading-tight -mt-3">Estimated walking time*</h4>
			
			<error class="mt-8 rounded-lg" colour="blue" icon="info_circle" title="Before you begin" body="We recommend you eat and use the bathroom before you start. Please carry a bottle of water with you." />
			
			<p class="block font-body text-white leading-tight text-xl mt-5 -mb-1">*Estimated distance and time assume you take the shortest route at a constant average walking speed. This is the total distance from your current location to the last checkpoint, passing through all the checkpoints in order.</p>
		</div>
		
		<a @click="start" @keypress.enter="start" tabindex="0" class="fixed bottom-0 left-0 w-full font-sans border-none bg-red-600 text-red-80 text-3xl text-center leading-tight py-4 sm:py-8 no-underline cursor-pointer">
			START
		</a>
    </div>
</template>

<script>
import ErrorBox from '../components/ErrorBox.vue';
import Storages from 'js-storage';
import axios from 'axios';

export default {
    name: 'Start',
    path: '/start',
	components: {
		'error': ErrorBox
	},
	data() {
		return {
			error: '',
			storage: null,
			key: '',
			route: [],
			estimated_distance: 0,
			estimated_time: 0,
			user: {},
			location: {},
			online_config: {}
		}
	},
    created() {
        this.storage = Storages.localStorage;
		this.online_config = this.storage.get('online_config');
		this.getCurrentUser();
		
		var that = this;
		window.onmessage = function(event) {
			if (event.data.type == "location") {
				console.log("Received location data:");
				console.log(event.data);
				that.location = event.data.location;
			}
		}
    },
    methods: {
		getCurrentUser() {
			if (this.storage.isSet('route')) {
				this.key = this.storage.get('session_key');
				this.user = this.storage.get('authed_user');
				this.route = this.storage.get('route');
				this.estimated_distance = this.storage.get('estimated_distance');
				this.estimated_time = this.storage.get('estimated_time');
			} else {
				this.$router.replace('/plan');
			}
		},
		async getLocation() {
			return new Promise((resolve, reject) => {
				if(!("geolocation" in navigator)) {
					reject(new Error('Your browser does not support geolocation'));
				}
				
				navigator.geolocation.getCurrentPosition(pos => {
					resolve({
						latitude: pos.coords.latitude,
						longitude: pos.coords.longitude
					});
				}, err => {
					reject(err);
				});
			});
		},
		async locationCheck(result) {
			return new Promise(async (resolve, reject) => {
				switch (result.state) {
					case "prompt":
						this.showLocationRequest = true;
						resolve(null);
						break;
					case "denied":
						reject("You denied us access to your location. Please allow it in browser settings to play.");
						break;
					default:
						resolve(await this.getLocation());
						break;
				}
			});
		},
		async checkLocationPermission() {
			var that = this;
			return new Promise((resolve, reject) => {
				try {
					if (this.online_config.test_access_only !== true) {
						navigator.permissions.query({name:'geolocation'}).then(async (result) => {
							that.locationCheck(result)
							.then(location => {
								resolve(location);
							})
							.catch(error => {
								reject(error);
							});
						});
					} else {
						resolve(that.location);
					}
				} catch(e) {
					var err = e.message;
					
					if (err == "User denied Geolocation") {
						err = "You denied us access to your location. Please allow it in browser settings to play.";
					}
					
					reject(err);
				}
			});
		},
		async start() {
			this.error = "";
			var that = this;
			this.checkLocationPermission()
			.then(location => {
				that.location = location;
				
				if (that.location == null) {
					return;
				}
				
				that.begin();
			})
			.catch(error => {
				that.error = error;
			});
		},
		async begin() {
			if (this.location == null) {
				return;
			}
			
			var that = this;
			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/trip/start?key=' + this.key + '&lat=' + this.location.latitude + '&long=' + this.location.longitude)
			.then(function (response) {
				var data = response.data;
				
				if (data.success == true) {
					that.storage.set('active_challenge', true);
					that.storage.set('start_time', data.response.start);
					that.storage.set('progress', 0);
					that.storage.set('hints', []);
					that.storage.set('authed_user', data.response.user);
					that.$router.replace('/challenge');
				} else {
					that.error = data.response;
				}
			})
			.catch(function (error) {
				if (error.response) {
					var data = error.response.data;
					that.error = data.response;
				} else {
					that.error = "An unknown error has occured.";
				}
			});
		},
		cancel() {
			this.storage.remove('route');
			this.storage.remove('estimated_distance');
			this.storage.remove('estimated_time');
			this.$router.replace('/plan');
		},
		timeConvert(n) {
			var num = n;
			var hours = (num / 60);
			var rhours = Math.floor(hours);
			var minutes = (hours - rhours) * 60;
			var rminutes = Math.round(minutes);
			if (rminutes == 0) {
				return rhours + "h";
			} else if (rhours == 0) {
				return rminutes + "m";
			} else {
				return rhours + "h" + rminutes + "m";
			}
		}
    }
}
</script>